// Check that the length of the input string is less than or equal to the specified max length
const maxStrLength = maxLength => value =>
	value && value.length > maxLength ? `Max ${maxLength} characters` : undefined;

export default maxStrLength;
